import { ITestDefinition } from '../../models/testDefinition';
import { ITestResult } from '../../models/testResult';
import { IEnabledTest } from '../../models/teamTestConfig';
import { resolveUnitLabel, findEnabledTest } from '../utils/resolveUnitLabel';
import { Athlete } from './testingTypes';
import styles from './TestingSummaryStats.module.scss';

interface TestingSummaryStatsProps {
  categoryTests: ITestDefinition[];
  athletes: Athlete[];
  dateResultsMap: Record<string, ITestResult>;
  /** Config team: necessaria per mostrare la label personalizzata dell'unità */
  enabledTests?: IEnabledTest[];
}

export default function TestingSummaryStats({ categoryTests, athletes, dateResultsMap, enabledTests }: TestingSummaryStatsProps) {
  const getDateResultsForTest = (testId: string): ITestResult[] => {
    const results: ITestResult[] = [];
    athletes.forEach((athlete) => {
      const r = dateResultsMap[`${athlete.id}_${testId}`];
      if (r && r.value > 0) results.push(r);
    });
    return results;
  };

  const statCards = categoryTests
    .map((test: ITestDefinition) => {
      const dateResults = getDateResultsForTest(test.id);
      const values = dateResults.map((r) => r.value).filter((v) => v > 0);
      if (values.length === 0) return null;

      const avg = values.reduce((a, b) => a + b, 0) / values.length;
      const max = Math.max(...values);
      const min = Math.min(...values);

      return (
        <div key={test.id} className={styles.statCard}>
          <p className={styles.statTestName}>{test.name}</p>
          <div className={styles.statAvgRow}>
            <p className={styles.statAvgValue}>{avg.toFixed(1)}</p>
            {/* Mostra label personalizzata se configurata, altrimenti unità grezza */}
            <p className={styles.statAvgUnit}>
              {resolveUnitLabel(test.defaultUnit, findEnabledTest(test.id, enabledTests))} media
            </p>
          </div>
          <div className={styles.statMinMaxRow}>
            <div>
              <p className={styles.statMinMaxLabel}>Max</p>
              <p className={styles.statMaxValue}>{max.toFixed(1)}</p>
            </div>
            <div>
              <p className={styles.statMinMaxLabel}>Min</p>
              <p className={styles.statMinValue}>{min.toFixed(1)}</p>
            </div>
          </div>
        </div>
      );
    })
    .filter(Boolean);

  if (statCards.length > 0) {
    return <div className={styles.summaryGrid}>{statCards}</div>;
  }

  return (
    <div className={styles.summaryPlaceholder}>
      <p className={styles.summaryPlaceholderText}>
        Inserisci i risultati dei test per visualizzare le statistiche
      </p>
    </div>
  );
}
